import { createFileRoute } from "@tanstack/react-router";

import { SpotlightContainer } from "~/components/feature/spotlight/SpotlightContainer";

type SpotlightSearch = {
  period: string;
  lastUpdate?: string;
  periodicity?: string;
};

export const Route = createFileRoute("/spotlight")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SpotlightSearch => {
    const period = search.period as string;
    if (!period || period.trim() === "") {
      throw new Error("Period parameter is required");
    }
    const lastUpdate =
      typeof search.lastUpdate === "string" ? search.lastUpdate : undefined;
    const periodicityRaw =
      typeof search.periodicity === "string" ? search.periodicity : undefined;
    const periodicity =
      periodicityRaw === "Mensual" ||
      periodicityRaw === "Trimestral" ||
      periodicityRaw === "Anual"
        ? periodicityRaw
        : undefined;
    return {
      period,
      lastUpdate,
      periodicity,
    };
  },
});

function RouteComponent() {
  const { period, lastUpdate, periodicity } = Route.useSearch();
  return (
    <SpotlightContainer
      period={period}
      lastUpdate={lastUpdate}
      periodicity={periodicity}
    />
  );
}
